
export const getYearSelectOptions = () => {
  const currentYear = new Date().getFullYear();
  const targetYear = currentYear +1;
  let allYears = [];
  for (let x = 2012; x <= targetYear; x++) {
    allYears.unshift(x.toString());
  }
  return allYears
}